import { ROUTES, type BreadcrumbConfig, type RouteConfig, type RouteKey } from "config/routes";

type Translate = (key: string) => string;
type BreadcrumbItem = {
  label: string;
  to?: string;
};

function isRouteKey(key: string): key is RouteKey {
  return Object.prototype.hasOwnProperty.call(ROUTES, key);
}

function resolveTrail(key: RouteKey): BreadcrumbConfig[] {
  const trail: BreadcrumbConfig[] = [];
  let currentKey: RouteKey | undefined = key;

  while (currentKey && ROUTES[currentKey] && ROUTES[currentKey].breadcrumb) {
    const routeConfig: RouteConfig = ROUTES[currentKey];
    const config: BreadcrumbConfig | undefined = routeConfig.breadcrumb;
    if (!config) {
      break;
    }
    trail.unshift({
      ...config,
      to: config.to || routeConfig.path,
    });
    currentKey = config.parent;
  }

  return trail;
}

function makeBreadcrumbItem(
  t: Translate,
  config?: BreadcrumbConfig,
  override: Partial<BreadcrumbItem> = {}
): BreadcrumbItem | null {
  if (!config && !override.label) {
    return null;
  }

  return {
    label: override.label || t(config ? config.labelKey : ""),
    to: Object.prototype.hasOwnProperty.call(override, "to") ? override.to : config && config.to,
  };
}

export function buildBreadcrumbs(
  t: Translate,
  key: string,
  items: BreadcrumbItem[] = []
): BreadcrumbItem[] {
  if (!key || !isRouteKey(key) || !ROUTES[key].breadcrumb) {
    return items;
  }

  const breadcrumbs = [
    {
      label: t("navigation.label_home"),
      to: BASE_PATH + "/",
    },
    ...resolveTrail(key).map((config) => makeBreadcrumbItem(t, config)),
    ...items,
  ];

  return breadcrumbs.filter((item): item is BreadcrumbItem => Boolean(item));
}
